import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format price in Israeli locale with ₪ symbol
 * @param price - The price amount
 * @param locale - The locale to use (default: 'he-IL')
 * @returns Formatted price string
 */
export function formatPrice(price: number, locale: string = 'he-IL'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'ILS',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
}

/**
 * Format price with ₪ symbol (simple version for admin)
 * @param price - The price amount (number|string|null|undefined)
 * @returns Formatted price string like "₪ 123.45" with space
 */
export function formatMoney(price: number | string | null | undefined): string {
  const num = typeof price === 'number'
    ? price
    : price != null && price !== ''
    ? Number(price)
    : 0;
  const safe = Number.isFinite(num) ? num : 0;
  return `₪ ${safe.toFixed(2)}`;
}
